import React from "react";
import { Link } from "react-router-dom";
import "./navbar.css";

const Header = () => {
  return (
    <div className="header">
      <div className="headerLeft">
        <Link to="/" style={{ textDecoration: "none", color:'white' }}>
          <h1 className="title">Movie Hunter</h1>
        </Link>
        <Link to="/movies/popular" style={{ textDecoration: "none" }}>
          <span>Popular</span>
        </Link>
        <Link to={"/movies/top_rated"} style={{ textDecoration: "none" }}>
          {" "}
          <span>Top Rated</span>
        </Link>
        <Link to={"movies/upcoming"} style={{ textDecoration: "none" }}>
          <span>upcoming</span>
        </Link>
      </div>
    </div>
  );
};
export default Header;


